"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreFunctionalAvatar = _interopRequireDefault(require("@vfuk/core-functional-avatar"));
var _coreBaseProps = require("@vfuk/core-base-props");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var PhotoAvatar = function PhotoAvatar(_ref) {
  var image = _ref.image,
    size = _ref.size,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    onMouseUp = _ref.onMouseUp,
    onTouchStart = _ref.onTouchStart,
    onTouchEnd = _ref.onTouchEnd,
    href = _ref.href,
    id = _ref.id,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes,
    srText = _ref.srText,
    customRouterProps = _ref.customRouterProps;
  var componentName = 'PhotoAvatar';
  return /*#__PURE__*/_react["default"].createElement(_coreFunctionalAvatar["default"], {
    backgroundImage: {
      sm: {
        src: image
      }
    },
    size: size,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    onTouchStart: onTouchStart,
    onTouchEnd: onTouchEnd,
    href: href,
    id: id,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    componentName: componentName,
    dataAttributes: dataAttributes,
    srText: srText,
    customRouterProps: customRouterProps
  });
};
PhotoAvatar.displayName = "PhotoAvatar";
var _default = PhotoAvatar;
exports["default"] = _default;